/**
 * Created by liux on 2017/12/18.
 */
export default function (src,opt) {
  opt = Object.assign({el:'script',async:true,type:'text/javascript'},opt)
  var dom = document.createElement(opt.el);
  dom.type = opt.type;
  dom.async = opt.async;
  dom.src = src;
  document.getElementsByTagName('head')[0].appendChild(dom);
  return new Promise(function (reslove, reject) {
    dom.addEventListener('load',function () {
      reslove()
    });
    dom.addEventListener('error',function () {
      reject()
    })
  })
}